<section id="content" *ngIf="this.lang">
  <div class="page page-profile">

    <!-- page header -->
    <div class="pageheader">
      <h2>{{lang.viewCustomer }}</h2>
      <div class="page-bar">
        <ul class="page-breadcrumb">
          <li>
            <a [routerLink]="'/'+AppFrontRoutes.DASHBOARD"><i class="fa fa-home"></i>
              {{AppSettings.SITE_TITLE | titlecase}}</a>
          </li>
          <li>
            <a [routerLink]="'/'+AppFrontRoutes.CUSTOMERS_VIEW + '/' + this.id">{{lang.viewCustomer }}</a>
          </li>
          <li>
            <span *ngIf="single_data">{{ single_data.code }} / {{ single_data.bussines_name }}</span>
          </li>

        </ul>

        <div style="float: right;">
          <div class="social-icons">
            <!-- <a class="plus-vdead" (click)="viewServicing()"
              [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'">
              <i class="fa fa-list"></i>
            </a> -->

            <a class="plus-edit" [routerLink]="['/'+AppFrontRoutes.EDIT_CUSTOMER+'/'+this.id]"
              [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'"
              [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'">
              <i class="fa fa-edit"></i>
            </a>
          </div>
        </div>

      </div>
    </div>
    <!-- page content -->
    <div class="pagecontent">

      <!-- row -->
      <div class="row">
        <div class="col-md-12">
          <div class="tile tile-simple">

            <!-- tile body -->
            <div class="tile-body" [ngSwitch]="pageView">
              <div role="tabpanel" *ngSwitchCase="'list'">

                <!-- Nav tabs -->
                <ul class="nav nav-tabs tabs-dark" role="tablist">
                  <li role="presentation" [ngClass]="{ 'active':generalTab==='activeTab'}"><a href="#generalTab"
                      aria-controls="feedTab" role="tab" data-toggle="tab">{{ lang.generalData }}</a></li>

                  <li role="presentation" [ngClass]="{ 'active':operatingTab==='activeTab'}"><a href="#history"
                      aria-controls="history" role="tab" data-toggle="tab">{{
                      lang.history }}</a></li>


                </ul>

                <!-- <div class="social-icons">

                  <a class="plus-add" (click)="addServicing()">
                  <i class="fa fa-plus"></i>
                </a>
                </div> -->

                <div class="tab-content">

                  <div role="tabpanel" class="tab-pane active" id="generalTab">
                    <div class="tab-content">

                      <div class="tab-pane in active" id="panel_tab3_example1">

                        <div class="panel panel-default">
                          <div class="panel-heading">
                            Course Details
                          </div>
                          <div class="panel-body">


                            <div class="col-md-10">

                              <form role="form" id="serviceing_form" class="form-horizontal"
                                action="https://www.kaizencloud.eu/kaizencloud_new/index.php/academy/course_catalog_management"
                                method="post" enctype="multipart/form-data" novalidate="novalidate">

                                <div class="form-group">

                                  <label class="col-sm-2 control-label" for="form-field-1">Course Code</label>
                                  <div class="col-sm-4">
                                    <input class="form-control" name="catalog_code" type="text" required="" value="001">
                                  </div>


                                  <label class="col-sm-1 control-label" for="form-field-1">Category</label>
                                  <div class="col-sm-4">
                                    <select class="form-control" name="category" required="">
                                      <option value="">please select</option>
                                      <option value="Safety">Safety</option>
                                      <option value="Quality">Quality</option>
                                      <option value="Production">Production</option>
                                      <option value="Organization">Organization</option>
                                      <option value="Languages">Languages</option>
                                      <option value="Other">Other</option>
                                    </select>
                                  </div>

                                </div>

                                <div class="form-group">
                                  <label class="col-sm-2 control-label" for="form-field-1">
                                    Course Title </label>
                                  <div class="col-sm-9">
                                    <input class="form-control" value="test001" name="course_title" type="text"
                                      required="">
                                  </div>
                                </div>


                                <div class="form-group">
                                  <label class="col-sm-2 control-label" for="form-field-1">
                                    Description </label>
                                  <div class="col-sm-9">
                                    <textarea class="form-control" name="description" required=""> prova </textarea>
                                  </div>
                                </div>

                                <div class="form-group">
                                  <label class="col-sm-2 control-label" for="form-field-1">
                                    Course Validity </label>
                                  <div class="col-sm-4">
                                    <input class="form-control" name="period_count" type="text" required="" value="">
                                  </div>
                                  <label class="col-sm-1 control-label" for="form-field-1">
                                  </label>
                                  <div class="col-sm-4">
                                    <select class="form-control" name="period_type" required="">
                                      <option value="days" selected="">Days</option>
                                      <option value="week">week</option>
                                      <option value="month">month</option>
                                      <option value="year">year</option>
                                    </select>
                                  </div>
                                </div>

                                <div _ngcontent-c8="" class="form-group col-sm-12">
                                  <label _ngcontent-c8="">Teaching Material</label>
                                  <!--bindings={
                          "ng-reflect-ng-for-of": "[object Object]"
                        }--><div _ngcontent-c8="" class="form-group row ng-untouched ng-pristine ng-valid" ng-reflect-name="0">
                                    <div _ngcontent-c8="" class="col-sm-12">
                                      <input _ngcontent-c8="" class="filestyle ng-untouched ng-pristine ng-valid" data-buttontext="Choose file" formcontrolname="link" type="file" ng-reflect-name="link" id="filestyle-0" tabindex="-1" style="display: none;"><div class="bootstrap-filestyle input-group"><div name="filedrag" style="position: absolute; width: 100%; height: 34px; z-index: -1;"></div><input type="text" class="form-control " placeholder="" disabled="" style="border-top-left-radius: 0.25rem; border-bottom-left-radius: 0.25rem;"> <span class="group-span-filestyle input-group-btn" tabindex="0"><label for="filestyle-0" style="margin-bottom: 0;" class="btn btn-default "><i class="fa fa-inbox mr-5"></i><span class="buttonText">Choose file</span></label></span></div>
                        
                                        <!--bindings={
                          "ng-reflect-ng-template-outlet-context": "[object Object]",
                          "ng-reflect-ng-template-outlet": "[object Object]"
                        }-->
                                <!--bindings={
                          "ng-reflect-ng-for-of": "[object Object]"
                        }--><div _ngcontent-c8="">
                                  <!--bindings={
                          "ng-reflect-ng-if": "false"
                        }-->
                                </div>
                              
                                    </div>
                        
                                  </div>
                        
                                </div>

                                <div class="form-group">
                                  <label class="col-sm-2 control-label" for="form-field-2">
                                    Notes </label>
                                  <div class="col-sm-9">
                                    <textarea class="form-control" name="notes">         </textarea>
                                  </div>
                                </div>

                                <div class="panel-footer">
                                  <input type="hidden" name="action" value="course_catalog_form_update">
                                  <input type="hidden" name="catalog_id" value="709">
                                  <input name="form_submit" class="btn btn-light-grey" type="submit" value="Save">
                                </div>

                              </form>

                            </div>

                            <div class="col-md-2">
                              <!-- <a class="btn btn-purple btn-block" onclick="final_test_html('709','001');" href="javascript:void(0);">final test setup</a> -->
                              <a class="btn btn-purple btn-block final_test" href="javascript:void(0);" (click)="addFinaltest()" >final test
                                setup</a>
                              <a class="btn btn-purple btn-block satisfaction_test" href="#">Satisfaction test setup</a>
                            </div>


                          </div>




                        </div>

                        <div class="panel panel-default">
                          <div class="panel-heading">
                            Teachers
                          </div>
                          <div class="panel-body">

                            <div class="table-responsive">
                              <table class="table table-striped">
                                <thead>
                                  <tr>
                                    <th>Name</th>
                                    <th>Surname</th>
                                    <th>Scope of teaching</th>
                                    <th>Basic Level</th>
                                    <th>Current Level</th>
                                    <th>Qualification date</th>
                                    <th>Available </th>
                                  </tr>
                                </thead>
                                <tbody>

                                </tbody>
                              </table>
                            </div>

                          </div>
                        </div>

                        <div class="panel panel-default">

                          <div class="panel-heading">
                            <a href="javascript:void(0);" (click)="addModules()"  id="modules_add" style="margin-top: -6px;"
                              class="btn btn-light-grey btn-sm pull-right">
                              <i class="fa fa-plus fa-fw">
                              </i>add module </a>
                            Modules
                          </div>

                          <div class="panel-body">

                            <div class="table-responsive">
                              <table class="table table-striped">
                                <thead>
                                  <tr>
                                    <th>Module Number </th>
                                    <th>Title </th>
                                    <th>Type </th>
                                    <th>Duration (hours) </th>
                                    <th>Topic</th>
                                    <th></th>
                                    <th width="10%">Action</th>
                                  </tr>
                                </thead>
                                <tbody class="all_modules">



                                  <tr>
                                    <td>01</td>
                                    <td>introduzione</td>
                                    <td>Theory</td>
                                    <td>8</td>
                                    <td>Argo2, Argo1</td>
                                    <td>
                                      <a class="btn btn-purple btn-sm modules_test" data-id="704"
                                        href="javascript:void(0);"> Test</a>
                                    </td>

                                    <td>
                                      <div class="btn-group show-on-hover">
                                        <a href="javascript:;" class="dropdown-toggle" data-toggle="dropdown">
                                          <i class="fa fa-bars fa-6" aria-hidden="true"></i>
                                        </a>
                                        <ul class="dropdown-menu" role="menu">
                                          <li>
                                            <a href="javascript:void(0)" class="modules_edit" data-id="704"><i
                                                class="fa fa-pencil-square-o fa-fw text-yellow mar-rt-8"></i>Modify</a>
                                          </li>
                                          <li>
                                            <a href="javascript:void(0)" class="modules_delete" data-id="704"><i
                                                class="fa fa-trash-o fa-fw text-red mar-rt-8"></i>Erase</a>
                                          </li>
                                        </ul>
                                      </div>
                                    </td>


                                  </tr>



                                  <tr>
                                    <td>02</td>
                                    <td>CAD</td>
                                    <td>Theory</td>
                                    <td>8</td>
                                    <td>CAD1</td>
                                    <td>
                                      <a class="btn btn-purple btn-sm modules_test" data-id="705"
                                        href="javascript:void(0);"> Test</a>
                                    </td>

                                    <td>
                                      <div class="btn-group show-on-hover">
                                        <a href="javascript:;" class="dropdown-toggle" data-toggle="dropdown">
                                          <i class="fa fa-bars fa-6" aria-hidden="true"></i>
                                        </a>
                                        <ul class="dropdown-menu" role="menu">
                                          <li>
                                            <a href="javascript:void(0)" class="modules_edit" data-id="705"><i
                                                class="fa fa-pencil-square-o fa-fw text-yellow mar-rt-8"></i>Modify</a>
                                          </li>
                                          <li>
                                            <a href="javascript:void(0)" class="modules_delete" data-id="705"><i
                                                class="fa fa-trash-o fa-fw text-red mar-rt-8"></i>Erase</a>
                                          </li>
                                        </ul>
                                      </div>
                                    </td>


                                  </tr>


                                </tbody>
                              </table>
                            </div>

                          </div>

                        </div>



                      </div>

                      <div class="tab-pane in" id="panel_tab3_example2">

                        <h4>General Resume</h4>
                        <div class="table-responsive">
                          <div class="table-responsive">
                            <table class="table table-striped table-hover table-bordered">
                              <thead>
                                <tr>
                                  <th>Instances</th>
                                  <th>Total Hours</th>
                                  <th>Total Attendies</th>
                                  <th>Average Level</th>
                                  <th>Average Course Score</th>
                                  <th>Average Teacher Score</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td><span id="span_sdate"></span> (<span id="span_edate"></span>)</td>
                                  <td>16</td>
                                  <td>0</td>
                                  <td><span id="average_lavel"></span></td>
                                  <td>%</td>
                                  <td>%</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>

                        <div class="clearfix"></div>

                        <h4>INSTANCE</h4>
                        <div class="table-responsive">
                          <div class="table-responsive">
                            <table class="table table-striped table-hover table-bordered">
                              <thead>
                                <tr>
                                  <th>Instances</th>
                                  <th>Start Date</th>
                                  <th>End Date</th>
                                  <th>Status</th>
                                  <th>Customer</th>
                                  <th>Attendies</th>
                                  <th>Teacher</th>
                                  <th>Average course level</th>
                                  <th>Course Score</th>
                                  <th>Teacher Score</th>
                                </tr>
                              </thead>
                              <tbody>
                              </tbody>
                            </table>
                          </div>
                        </div>

                      </div>

                    </div>

                  </div>

                  <div role="tabpanel" class="tab-pane" id="history">
                    <div class="tab-content">


                      <h4>General Resume</h4>
                      <div class="table-responsive">
                        <div class="table-responsive">
                          <table class="table table-striped table-hover table-bordered">
                            <thead>
                              <tr>
                                <th>{{ lang.instances }}</th>
                                <th>{{ lang.totalHours }}</th>
                                <th>{{ lang.totalAttendies }}</th>
                                <th>{{ lang.averageLevel }}</th>
                                <th>{{ lang.averageCourseScore }}</th>
                                <th>{{ lang.averageTeacherScore }}</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let record of history_data">
                                <td><span id="span_sdate"></span> (<span id="span_edate"></span>)</td>
                                <td>{{ record.total_hours }}</td>
                                <td>{{ record.total_attendies }}</td>
                                <td><span id="average_lavel"></span></td>
                                <td>{{ record.teacher_score_avg }} %</td>
                                <td>{{ record.course_score_avg }} %</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>


                      <h4>{{ lang.instances }}</h4>
                      <div class="table-responsive">
                        <div class="table-responsive">
                          <table class="table table-striped table-hover table-bordered">
                            <thead>
                              <tr>
                                <th>{{ lang.instances }}</th>
                                <th>{{ lang.startDate }}</th>
                                <th>{{ lang.endDate }}</th>
                                <th>{{ lang.status }}</th>
                                <th>{{ lang.customer }}</th>
                                <th>{{ lang.attendies }}</th>
                                <th>{{ lang.teacher }}</th>
                                <th>{{ lang.averageCourseLevel }}</th>
                                <th>{{ lang.courseScore }}</th>
                                <th>{{ lang.teacherScore }}</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let ins_record of instance_data let i = index">
                               <td>{{ i + 1 }}</td>
                               <td>{{ ins_record.sc_date }}</td>
                               <td>{{ ins_record.end_date }}</td>
                               <td>{{ ins_record.status }}</td>
                               <td>{{ ins_record.get_cust_data }}</td>
                               <td>{{ ins_record.attendies }}</td>
                               <td><a href="#">{{ ins_record.fname }}</a></td>
                               <td>{{ ins_record.avg_lebels }}</td>
                               <td>{{ ins_record.course_score }}</td>
                               <td>{{ ins_record.teacher_score }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>


                    </div>

                  </div>





                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

    </div>
  </div>
</section>

<div class="modal splash fade" id="datatableExport1" tabindex="-1" role="dialog" aria-hidden="true">

  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-header">
        <h3 class="modal-title custom-font">{{ ollang?.selectColumns }}</h3>
      </div>

      <div class="modal-body column_export">
        <div class="row select-alls">
          <label class="checkbox checkbox-custom-alt checkbox-custom-sm"> <input type="checkbox"
              (change)="export1_select_deselect_all($event)"><i></i> {{ ollang?.selectAll }} </label>
        </div>
        <div class="row flexs">

          <div class="active-left">
            <h2>{{ ollang?.activeColumns }}</h2>

            <div class="row" *ngFor="let option of datatableCols1">
              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                <input type="checkbox" value="{{option.id}}" [checked]="option.isSelected" class="col_select1"
                  (change)="export1_select_deselect($event)"><i></i> {{option.value}}
              </label>
            </div>

          </div>

        </div>

      </div>

      <div class="modal-footer">
        <div id="datatableExportBtn1" class="export_dynamic_btn">
        </div>
        <button class="btn btn-warning" data-dismiss="modal">{{ ollang?.close }}</button>
      </div>

    </div>
  </div>
</div>

<div class="modal splash fade" id="datatableExport2" tabindex="-1" role="dialog" aria-hidden="true">

  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-header">
        <h3 class="modal-title custom-font">{{ emplang?.selectColumns }}</h3>
      </div>

      <div class="modal-body column_export">
        <div class="row select-alls">
          <label class="checkbox checkbox-custom-alt checkbox-custom-sm"> <input type="checkbox"
              (change)="export2_select_deselect_all($event)"><i></i> {{ emplang?.selectAll }} </label>
        </div>
        <div class="row flexs">

          <div class="active-left">
            <h2>{{ emplang?.activeColumns }}</h2>

            <div class="row" *ngFor="let option of datatableCols2">
              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                <input type="checkbox" value="{{option.id}}" [checked]="option.isSelected" class="col_select1"
                  (change)="export2_select_deselect($event)"><i></i> {{option.value}}
              </label>
            </div>

          </div>

        </div>

      </div>

      <div class="modal-footer">
        <div id="datatableExportBtn2" class="export_dynamic_btn">
        </div>
        <button class="btn btn-warning" data-dismiss="modal">{{ emplang?.close }}</button>
      </div>

    </div>
  </div>
</div>


<div class="modal splash fade" id="datatableImport2" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <!-- <div class="modal-header">
          <h3 class="modal-title custom-font">IMPORT HOURLY DATA</h3>
          <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
            <span aria-hidden="true">&times;</span>
          </button>
      
        </div>
         -->
      <div class="modal-header">
        <h4 class="modal-title pull-left">Import Employee Data</h4>
        <button type="button" class="close pull-right" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>


      <div class="modal-body column_export">
        <div class="row">
          <form>
            <input type="file" class="filestyle" id="file" name='file' data-buttonText="Choose file"
              (change)="onPhotoPickerChange($event)" appFileDesign>

            <font style="vertical-align: inherit;">
              <font style="vertical-align: inherit;"><a
                  href="http://vmi313621.contaboserver.net/Software_backend/uploads/csv_files/template_customers_employees.csv">Click
                  Here</a> {{ emplang?.todownloadtocsv}}</font>
            </font>
          </form>
        </div>
      </div>

      <div class="modal-footer">
        <div id="datatableExportBtn2" class="export_dynamic_btn">
        </div>
        <button type="button" class="btn btn-primary" (click)="onclick(this.id)">{{ emplang?.submit }}</button>
        <!-- <button class="btn btn-warning" data-dismiss="modal">Close</button>-->
        <button type="button" class="btn btn-warning" data-dismiss="modal">{{ emplang?.close }}</button>

      </div>
    </div>
  </div>
</div>

<div class="modal splash fade" id="datatableExport3" tabindex="-1" role="dialog" aria-hidden="true">

  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-header">
        <h3 class="modal-title custom-font">{{ clang?.export }}</h3>
      </div>

      <div class="modal-body column_export">
        <div class="row select-alls">
          <!-- <label class="checkbox checkbox-custom-alt checkbox-custom-sm"> <input type="checkbox"
                (change)="export3_select_deselect_all($event)"><i></i> {{ clang?.selectAll }} </label> -->
        </div>
        <div class="row flexs">

          <div class="active-left">
            <!-- <h2>{{ clang?.activeColumns }}</h2> -->

            <!-- <div class="row" *ngFor="let option of datatableCols3">
                <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                  <input type="checkbox" value="{{option.id}}" [checked]="option.isSelected" class="col_select1"
                    (change)="export3_select_deselect($event)"><i></i> {{option.value}}
                </label>
              </div> -->
            <div id="datatableExportBtn3" class="export_dynamic_btn">


            </div>

          </div>

        </div>

        <div class="modal-footer">
          <div class="export_dynamic_btn">
          </div>
          <button class="btn btn-warning" data-dismiss="modal">{{ alang?.close }}</button>
        </div>

      </div>
    </div>
  </div>
</div>


<div class="modal splash fade" id="datatableExport4" tabindex="-1" role="dialog" aria-hidden="true">

  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-header">
        <h3 class="modal-title custom-font">{{ alang?.selectColumns }}</h3>
      </div>

      <div class="modal-body column_export">
        <div class="row select-alls">
          <label class="checkbox checkbox-custom-alt checkbox-custom-sm"> <input type="checkbox"
              (change)="export4_select_deselect_all($event)"><i></i> {{ alang?.selectAll }} </label>
        </div>
        <div class="row flexs">

          <div class="active-left">
            <h2>{{ plang?.activeColumns }}</h2>

            <div class="row" *ngFor="let option of datatableCols4">
              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                <input type="checkbox" value="{{option.id}}" [checked]="option.isSelected" class="col_select1"
                  (change)="export4_select_deselect($event)"><i></i> {{option.value}}
              </label>
            </div>

          </div>

        </div>

      </div>

      <div class="modal-footer">
        <div id="datatableExportBtn4" class="export_dynamic_btn">
        </div>
        <button class="btn btn-warning" data-dismiss="modal">{{ alang?.close }}</button>
      </div>

    </div>
  </div>
</div>



<div class="modal splash fade" id="datatableExport5" tabindex="-1" role="dialog" aria-hidden="true">

  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-header">
        <h3 class="modal-title custom-font">{{ plang?.selectColumns }}</h3>
      </div>

      <div class="modal-body column_export">
        <div class="row select-alls">
          <label class="checkbox checkbox-custom-alt checkbox-custom-sm"> <input type="checkbox"
              (change)="export5_select_deselect_all($event)"><i></i> {{ plang?.selectAll }} </label>
        </div>
        <div class="row flexs">

          <div class="active-left">
            <h2>{{ plang?.activeColumns }}</h2>

            <div class="row" *ngFor="let option of datatableCols5">
              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                <input type="checkbox" value="{{option.id}}" [checked]="option.isSelected" class="col_select1"
                  (change)="export5_select_deselect($event)"><i></i> {{option.value}}
              </label>
            </div>

          </div>

        </div>

      </div>

      <div class="modal-footer">
        <div id="datatableExportBtn5" class="export_dynamic_btn">
        </div>
        <button class="btn btn-warning" data-dismiss="modal">{{ plang?.close }}</button>
      </div>

    </div>
  </div>
</div>